// extracted by mini-css-extract-plugin
module.exports = {"contentHeadingWrapper":"_13hrQzKrKEMwUhMzQB4Cbw","sectionHeading":"_315U3H7tukEm-sfw-jyFMY"};